import { useEffect, useRef } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import {
    feedsDataAtom,
    feedsPageStateAtom,
    feedsUserContextAtom,
    setAtomFeedsListTableViewState,
    tableFiltersAtom,
    tableStateAtom,
    tableStatsAtom,
    tableViewAtom,
} from '../../list/feeds_list_atoms';
import { feedsSearchFormAtom } from '../search/feeds_search_atoms';
import { FeedsDataItem } from '../feeds_list_types';
import { tableDataVM, tableStateVM, tableStatsVM, tableViewVM } from '../../../../core/table/table_view_models';
import { feedsListPageStateVM } from '../feeds_list_view_models';
import { feedsSearchStateVM } from '../search/feeds_search_view_models';

export const useFeedsListDestroy = (): void => {
    const atomsDestroyed = useRef(false);
    // page
    const setPageState = useSetImmerAtom(feedsPageStateAtom);
    const setUserContext = useSetImmerAtom(feedsUserContextAtom);

    // form
    const setSearchForm = useSetImmerAtom(feedsSearchFormAtom);

    // table
    const setTableState = useSetImmerAtom(tableStateAtom);
    const setTableData = useSetImmerAtom(feedsDataAtom);
    const setView = useSetImmerAtom(tableViewAtom);
    const setStats = useSetImmerAtom(tableStatsAtom);
    const setFilter = useSetImmerAtom(tableFiltersAtom);

    useEffect(() => {
        atomsDestroyed.current = false;

        return (): void => {
            console.log('[FeedsDestroy] unmount cleanup running. atomsDestroyed:', atomsDestroyed.current);
            // page
            setPageState(() => feedsListPageStateVM());
            setUserContext(() => ({ userType: 'CE', isImpersonating: false, affiliations: [] }));
            // form
            setSearchForm(() => feedsSearchStateVM());
            // table
            setAtomFeedsListTableViewState(atomsDestroyed.current);
            setTableState(() => tableStateVM());
            setTableData(() => tableDataVM<FeedsDataItem>());
            setView(() => tableViewVM());
            setStats(() => tableStatsVM());
            setFilter(() => ({}));

            atomsDestroyed.current = true;
        };
    }, [setPageState, setUserContext, setSearchForm, setTableState, setTableData, setView, setStats, setFilter]);
};
